<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="dark"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
    <li class="dark"><a routerLink="/seo">SEO</a></li>
    <li class="disabled"><a routerLink="/seo/settings">Settings</a></li>
  </ul>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>

<!--//jeb if there are no keywords, prompt to come here from seo dashboard -->
<h2>Add Keyword</h2>
<input type="text" class="default form-control new-keyword" placeholder="New Keyword" [(ngModel)]="newKeyword"
  name="newKeyword" />
<br />
<button type="button" class="btn btn-success" (click)="addKeyword()">
  <i class="glyphicon glyphicon-plus"></i>
</button>
<td>
  <i class="glyphicon glyphicon-trash" (click)="removeKeyword()"></i>
</td>
